import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { INotificationSettingsState } from './notification-settings.reducers';
import * as fromReducer from './notification-settings.reducers';

const getNotificationSettingsState =
  createFeatureSelector<INotificationSettingsState>('notificationSettings');

export const getNotificationSettingsActionState = createSelector(
  getNotificationSettingsState,
  fromReducer.getNotificationSettingsActionState
);

export const getNotificationSettings = createSelector(
  getNotificationSettingsState,
  fromReducer.getNotificationSettings
);

export const getChangeNotificationSettingsActionState = createSelector(
  getNotificationSettingsState,
  fromReducer.getChangeNotificationSettingsActionState
);
